"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    baseRequirements: {
        "us history studies since 1877": 1,
        "united states government": 0.5,
        "economics w/emph free enterpr": 0.5,
        /* new courses added 2018-06-26 */
        "ap u.s. government & politics": 0.5,
        "ap united states history": 1
    },
    oneAdditionalCredit: {
        "world history studies": 1,
        "world geography studies": 1,
        "ap international engl language": 1,
        "ib global politics higher lvl": 2,
        "ib soc & cultrl anthro std lvl": 2,
        "ib global politics stand level": 2
    }
};
//# sourceMappingURL=socialStudies.js.map


//////////////////
// WEBPACK FOOTER
// ../validation/build/pathValidations/core/socialStudies.js
// module id = 450
// module chunks = 22